import USBMenu from "@usb-shield/react-menu";
import { CONTACT_US_COUNTRIES } from "../constants";
import { Link } from "react-router-dom";
import { USBIconExternalLink } from "@usb-shield/react-icons";
import { useEffect, useState } from "react";

const CountriesDropdown = () => {
  const [sortedLinks, setSortedLinks] = useState([...CONTACT_US_COUNTRIES]);

  useEffect(() => {
    const browserLang = navigator.language; // e.g., "en-US", "nn", "no", "nb-NO",
    const primaryLang = browserLang.split("-")[0]; // e.g., "en", "nn", "no", "nb"
    // Norwegian language variants mapping
    const norwegianCodes = ["nb", "nn", "no"];

    const sorted = [...CONTACT_US_COUNTRIES].sort((a, b) => {
      const aLangPrimary = a.language.split("-")[0];
      const bLangPrimary = b.language.split("-")[0];

      const aExactMatch = a.language === browserLang;
      const bExactMatch = b.language === browserLang;

      const aPrimaryMatch =
        aLangPrimary === primaryLang ||
        (norwegianCodes.includes(primaryLang) &&
          norwegianCodes.includes(aLangPrimary));
      const bPrimaryMatch =
        bLangPrimary === primaryLang ||
        (norwegianCodes.includes(primaryLang) &&
          norwegianCodes.includes(bLangPrimary));

      if (aExactMatch) return -1;
      if (bExactMatch) return 1;
      if (aPrimaryMatch && !bPrimaryMatch) return -1;
      if (bPrimaryMatch && !aPrimaryMatch) return 1;
      return 0;
    });

    setSortedLinks(sorted);
  }, []);

  return (
    <div className="d-flex align-center mr-10">
      <USBMenu>
        <USBMenu.Trigger className="dropdown-menu-trigger">
          Contact Us
          <USBMenu.TriggerIcon />
        </USBMenu.Trigger>
        <USBMenu.Content
          position={"bottom"}
          align={"center"}
          aria-label="Contact Us actions"
          role="menu"
        >
          {sortedLinks.map((item) => (
            <USBMenu.Item key={item.language}>
              <Link
                className="no-style country-link"
                to={item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="d-flex align-center justify-content-between">
                  <div className="d-flex align-center">
                    <img
                      data-src={item.flag}
                      alt={`${item.label} flag`}
                      ref={(img) => {
                        if (img) img.src = item.flag;
                      }}
                      className="m-2"
                      width="26"
                      height="16"
                    />
                    <div className="ps-2">
                      <p
                        className="country-label"
                        htmlFor={`country-${item.language}`}
                      >
                        {item.label}
                      </p>
                      <small htmlFor={`country-${item.url_label_text}`}>
                        {item.url_label_text}
                      </small>
                    </div>
                  </div>
                  <USBIconExternalLink
                    size={"0.75rem"}
                    colorVariant={"brand-primary"}
                  />
                </div>
              </Link>
            </USBMenu.Item>
          ))}
        </USBMenu.Content>
      </USBMenu>
    </div>
  );
};

export default CountriesDropdown;
